<template lang="pug">
  v-container.dataset(style="height:100%").d-flex.flex-column
    Breadcrumbs(:data="breadcrumbs")
    v-progress-linear(indeterminate class="mb-2" v-if="!dataReady").mt-12
    div(v-if="dataReady")
      Heading(
        :title="dataset.title"
        :description="dataset.description"
        :s3-details="dataset.s3_details"
        :number-of-records="dataset.number_of_records"
        :url="dataset.data_source"
        :download="dataset.s3_location"
        :filesize="dataset.s3_details ? dataset.s3_details.ContentLength: 0"
        :ext-url="dataset.external_url"
        show-details
        :token="token"
      )
      .d-flex.align-center(v-if="dataset.visibility=='protected' && !dataset.last_update")
        v-spacer
        v-text-field(v-model="token" label="Access Token" outlined hide-details dense @submit="getDataset")
        v-btn.ml-4(color="primary" @click="getDataset") Submit
        v-spacer
      v-card(outlined).mt-8
        div.text-center.align-center.ma-8.body-1(v-if="dataset.external_url") This resource has been identified as containing Arlington-specific information and a link to the dataset is provided. Go to the data source for additional information.
        v-tabs(centered v-model="tab" v-if="dataset.data_source")
          v-tab Data Views
          v-tab Column Details
          v-tab Detailed Metadata
          v-tab-item(v-if="dataset.data_source")
            v-card(flat)
              v-row.px-4.py-1
                v-col(v-for="(view, index) in dataset.dataviews" :key="view.title" cols="12" sm="6" md="4" lg="3").pa-0
                  Datacard(
                    :title="view.title"
                    :description="view.description"
                    :url="view.query_url"
                    :to="{name:'dataview',params:{datasetId:dataset.id,dataviewId:index},query:{token:token}}"
                    rows=4
                    show-view-nav
                    :token="token"
                  ).ma-4
          v-tab-item
            v-card(flat)
              v-simple-table
                tbody
                  tr
                    td.font-weight-bold Title
                    td.font-weight-bold Description
                  tr(v-for="column in dataset.datacolumns" :key="column.title")
                    td {{column.column_name}}
                    td {{column.column_description}}
          v-tab-item
            v-card(flat)
              Metadata(:data="dataset")
      v-spacer
      DatasetShowcase(
        v-if="dataset.related_dataset && dataset.related_dataset.length"
        title="Related Datasets"
        :data="dataset.related_dataset"
      ).mt-12
</template>

<script>
import service from '../data/service'
import Breadcrumbs from '@/components/Breadcrumbs.vue'
import Datacard from '@/components/Datacard.vue'
import DatasetShowcase from '@/components/DatasetShowcase.vue'
import Heading from '@/components/Heading.vue'
import Metadata from '@/components/Metadata.vue'

export default {
  data: () => ({
    dataset: {},
    tab: 0,
    dataReady: false,
    token: null
  }),
  components: {
    Breadcrumbs,
    Datacard,
    DatasetShowcase,
    Heading,
    Metadata
  },
  methods: {
    getDataset() {
      return service.getDataset(this.$route.params.id, this.token).then(data => {
        this.dataset = data;
        this.dataReady = true;
      })
    },
    update() {
      if(this.$route.query && this.$route.query.token)
        this.token = this.$route.query.token
      this.getDataset()
      if(this.$route.query && this.$route.query.tab)
        this.tab = parseInt(this.$route.query.tab)
    }
  },
  mounted() {
    this.update()
  },
  watch: {
    $route() {
      this.update()
    }
  },
  computed: {
    breadcrumbs() {
      if(this.dataset.collection)
        return [{
          text: this.dataset.collection.title,
          to: { name: 'collection', params: { id: this.dataset.collection.id } },
          super: 'Collection'
        }]
      else
        return []
    },
    defaultView() {
      return {
        title: "All Data",
        description: "View of full dataset.",
        query_url: this.dataset.data_source,
        query_explanation: "Unfiltered view of dataset.",
        last_update: this.dataset.last_update
      }
    }
  }
}
</script>